import { NgModule } from '@angular/core';
import {
  mapToCanActivate,
  mapToCanActivateChild,
  RouterModule,
  Routes,
} from '@angular/router';
import {
  AuthenticationGuard,
  AuthorizationGuard,
  AutologinGuard,
  PasswordManagerGuard,
} from '@pwc-bei/security';
import { RoutePath } from 'src/app/enums/route-path.enum';
import { AuthorityCodeEnum } from 'src/app/enums/security/authority-code.enum';
import { AccessPlanGuard } from 'src/app/guard/access-plan-guard';
import { ProfileRequiredGuard } from 'src/app/guard/profile-required-guard';
import { TermsAndConditionsGuard } from 'src/app/guard/terms-and-conditions-guard';
import { CallFaqListComponent } from './faq/components/callFaq-list.component';
import { HelpDeskComponent } from './help-desk/components/help-desk-form/call-help-desk.component';
import { HelpDeskSuccessfulRequestComponent } from './help-desk/pages/help-desk-successful-request/call-help-desk-successful-request.component';
import { UpgradePlanFormComponent } from './tax-break/components/upgrade-plan/upgrade-plan-form/upgrade-plan-form.component';

/* ----- GUARDS ----- */
/* const profileRequiredGuard = mapToCanActivate([ProfileRequiredGuard]);
const profileRequiredGuardChild = mapToCanActivateChild([ProfileRequiredGuard]);
const termsAndConditionsGuard = mapToCanActivate([TermsAndConditionsGuard]);
const termsAndConditionsGuardChild = mapToCanActivateChild([TermsAndConditionsGuard]);
const accessPlanGuard = mapToCanActivate([AccessPlanGuard]);
const accessPlanGuardChild = mapToCanActivateChild([AccessPlanGuard]);
const authorizationGuard = mapToCanActivate([AuthorizationGuard]);
const authorizationGuardChild = mapToCanActivateChild([AuthorizationGuard]);
const authenticationGuard = mapToCanActivate([AuthenticationGuard]);
const authenticationGuardChild = mapToCanActivateChild([AuthenticationGuard]);
const autologinGuard = mapToCanActivate([AutologinGuard]);
const autologinGuardChild = mapToCanActivateChild([AutologinGuard]);*/

const routes: Routes = [
  {
    path: '',
    // component: LayoutComponent,
    canActivateChild: [TermsAndConditionsGuard],
    children: [
      {
        path: '',
        canActivate: [
          AutologinGuard,
          AuthenticationGuard,
          AuthorizationGuard,
          PasswordManagerGuard,
          TermsAndConditionsGuard,
          ProfileRequiredGuard,
        ],
        canActivateChild: [
          AutologinGuard,
          AuthenticationGuard,
          AuthorizationGuard,
          PasswordManagerGuard,
          TermsAndConditionsGuard,
          ProfileRequiredGuard,
        ],
        redirectTo: RoutePath.TAX_BREAK,
        pathMatch: 'full',
      },
      {
        path: RoutePath.TAX_BREAK,
        canActivate: [
          AutologinGuard,
          AuthenticationGuard,
          AuthorizationGuard,
          PasswordManagerGuard,
          TermsAndConditionsGuard,
          ProfileRequiredGuard,
        ],
        canActivateChild: [
          AutologinGuard,
          AuthenticationGuard,
          AuthorizationGuard,
          PasswordManagerGuard,
          TermsAndConditionsGuard,
          ProfileRequiredGuard,
        ],
        loadChildren: () =>
          import('./tax-break/tax-break.module').then(
            (m) => m.TaxBreakBandiModule,
          ),
      },
      {
        path: RoutePath.QUOTATION,
        canActivate: [
          AutologinGuard,
          AuthenticationGuard,
          AuthorizationGuard,
          PasswordManagerGuard,
          TermsAndConditionsGuard,
          ProfileRequiredGuard,
        ],
        canActivateChild: [
          AutologinGuard,
          AuthenticationGuard,
          AuthorizationGuard,
          PasswordManagerGuard,
          TermsAndConditionsGuard,
          ProfileRequiredGuard,
        ],
        loadChildren: () =>
          import('./quotation/quotation.module').then((m) => m.QuotationModule),
      },
      {
        path: RoutePath.PROJECT,
        canActivate: [
          AutologinGuard,
          AuthenticationGuard,
          AuthorizationGuard,
          PasswordManagerGuard,
          TermsAndConditionsGuard,
          ProfileRequiredGuard,
        ],
        canActivateChild: [
          AutologinGuard,
          AuthenticationGuard,
          AuthorizationGuard,
          PasswordManagerGuard,
          TermsAndConditionsGuard,
          ProfileRequiredGuard,
        ],
        loadChildren: () =>
          import('./project/project.module').then((m) => m.ProjectModule),
      },
      {
        path: RoutePath.HELPDESK_LIST,
        canActivate: [
          AutologinGuard,
          AuthenticationGuard,
          AuthorizationGuard,
          PasswordManagerGuard,
        ],
        canActivateChild: [
          AutologinGuard,
          AuthenticationGuard,
          AuthorizationGuard,
          PasswordManagerGuard,
        ],
        loadChildren: () =>
          import('./help-desk/help-desk.module').then((m) => m.HelpDeskModule),
      },
      {
        path: RoutePath.EDUCATION_AREA,
        loadChildren: () =>
          import('./educatio-area/education-area.module').then(
            (m) => m.EducationAreaModule,
          ),
      },
      {
        path: RoutePath.GLOSSARY,
        loadChildren: () =>
          import('./glossary/glossary.module').then((m) => m.GlossaryModule),
      },
      {
        path: RoutePath.FAQ,
        canActivate: [
          AutologinGuard,
          AuthenticationGuard,
          AuthorizationGuard,
          PasswordManagerGuard,
        ],
        canActivateChild: [
          AutologinGuard,
          AuthenticationGuard,
          AuthorizationGuard,
          PasswordManagerGuard,
        ],
        component: CallFaqListComponent,
      },
      {
        path: RoutePath.HELPDESK,
        canActivate: [
          AutologinGuard,
          AuthenticationGuard,
          AuthorizationGuard,
          PasswordManagerGuard,
        ],
        canActivateChild: [
          AutologinGuard,
          AuthenticationGuard,
          AuthorizationGuard,
          PasswordManagerGuard,
        ],
        component: HelpDeskComponent,
      },
      {
        path:
          RoutePath.HELPDESK +
          RoutePath.SLASH +
          RoutePath.HELPDESK_SUCCESSFUL_REQUEST,
        canActivate: [
          AutologinGuard,
          AuthenticationGuard,
          AuthorizationGuard,
          PasswordManagerGuard,
        ],
        canActivateChild: [
          AutologinGuard,
          AuthenticationGuard,
          AuthorizationGuard,
          PasswordManagerGuard,
        ],
        component: HelpDeskSuccessfulRequestComponent,
      },
      {
        path: RoutePath.UPGRADE_PLAN,
        canActivate: [
          AutologinGuard,
          AuthenticationGuard,
          AuthorizationGuard,
          PasswordManagerGuard,
          AccessPlanGuard,
        ],
        canActivateChild: [
          AutologinGuard,
          AuthenticationGuard,
          AuthorizationGuard,
          PasswordManagerGuard,
        ],
        component: UpgradePlanFormComponent,
      },
    ],
    data: {
      authorities: [AuthorityCodeEnum.ROLE_BANDI_B2C_ACCESS],
      redirect: [RoutePath.B2B],
    },
  },
  {
    path: RoutePath.FAQ,
    canActivate: [AuthenticationGuard],
    component: CallFaqListComponent,
  },
  {
    path: RoutePath.HELPDESK,
    canActivate: [AuthenticationGuard],
    component: HelpDeskComponent,
  },
  {
    path: RoutePath.B2B,
    canActivate: [AuthenticationGuard, AuthorizationGuard],
    redirectTo: `/${RoutePath.REDIRECT}?url=${window.origin}/${RoutePath.B2B}/bandi&=_self`,
    pathMatch: 'full',
  },
  {
    path: RoutePath.PROFILE,
    canActivate: [AuthenticationGuard, AuthorizationGuard],
    redirectTo: `/${RoutePath.REDIRECT}?url=${window.origin}/${RoutePath.PROFILE}&=_self`,
    pathMatch: 'full',
  },
  {
    path: '**',
    redirectTo: '',
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class BandiRoutingModule {}
